<template>
  <div :class="$style.container">
    <div :class="['wf-table-row', $style.row]" @click="toggleOpen">
      <div :class="$style.label">
        <WfCheckbox
          v-if="selectable"
          :disabled="disabled"
          :status="status"
          @click.stop="handleCheck"
        />
        <slot name="title" />
      </div>
      <WfChevron v-if="expandable" :is-open="isOpen" />
    </div>
    <slot v-if="expandable && isOpen" name="content" />
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;

  :global(.wf-table-row) {
    height: auto;
    min-height: 44px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
}

.row {
  padding-left: v-bind(paddingLeft);
  padding-right: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.label {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
</style>

<script setup>
import { computed } from 'vue';
import WfCheckbox from '@/components/mainContent/WfCheckbox.vue';
import WfChevron from './WfChevron.vue';

const props = defineProps({
  expandable: {
    type: Boolean,
    default: false,
  },
  status: {
    type: String,
    default: 'unselected',
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  selectable: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  level: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['check', 'open']);

const toggleOpen = () => {
  if (!props.expandable) {
    return handleCheck();
  }

  emit('open', !props.isOpen);
};

const handleCheck = () => {
  emit('check');
};

const paddingLeft = computed(() => `${8 + props.level * 16}px`);
</script>
